import { render, staticRenderFns } from "./TaskCaptures.vue?vue&type=template&id=da401ac8"
import script from "./TaskCaptures.vue?vue&type=script&lang=js"
export * from "./TaskCaptures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports